module.exports = __webpack_public_path__ + "static/smartpci-logo-text-8111a8a146a9202f6ad649aa512647e5.svg";